import { getBlockTitle, uuidToId } from '@simpledotink/notion-utils'
import slugify from 'slugify'

/**
 *
 * @param pageId
 * @param recordMap
 * @param param2
 * @returns
 */
export const getCanonicalPageId = (
  pageId: string,
  recordMap: any,
  { uuid = true }: { uuid?: boolean } = {},
  siteMaps?: any,
  site?:any,
): string | null =>  {
  if (!pageId || !recordMap) return null

  const page = site.pages?.find((page) => page.pageId === pageId);
  const slug: string = page ? page.slug : '';
  const id = uuidToId(pageId)
  const block: any = recordMap.block[pageId]?.value

  if (block) {
    let title = slugify(getBlockTitle(block, recordMap), {
      lower: true,
      remove: /[/*+~.()'"!:@?-]/g
    })
      // if(site.siteId === '7ab5e460-a344-42e6-a5eb-fbb9809c9ef3') {
      //     title = encodeURIComponent(title)
      // }
      if ( ['cfa09a74-cc2d-4cda-be9f-dc32a3eac423','a246b50a-5815-4951-956c-58bd51970a0e'].includes(site.siteId ) && title.includes('#')) {
          title = title.replace(/#/g, '');
      }
    if (title) {
      if(site.siteId === "5feffab2-e6d9-40e0-8380-b98bb0ff92cc"){
        return `${slug}`
      }
     else if (uuid || !siteMaps[title]) {
        return `${title}-${id}`
      } else if (siteMaps[title]) {
        return title
      } else {
        return `${title}-${id}`
      }
    }
  }

  return id
}
